import { debounce } from 'lodash'
import { useCallback, useLayoutEffect, useState } from 'react'
import { getQuestionnaireFormsApi } from '../api/requester'

export const useSearchForms = ({ query, companyId, perPage = 10, timming = 300 }) => {
  const [data, setData] = useState([])
  const [total, setTotal] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const getQuestionnaireForms = useCallback(
    debounce(async ({ query, companyId, perPage }) => {
      if (query === '') {
        setData([])
        return
      }
      setLoading(true)
      try {
        const params = { query, company_id: companyId, per_page: perPage }
        const res = await getQuestionnaireFormsApi({ params })
        setTotal(res?.data?.total_counts)
        setData(res?.data?.questionnaire_forms)
      } catch (error) {
        console.error('Error fetching questionnaire forms:', error)
        setError(error)
      } finally {
        setLoading(false)
      }
    }, timming),
    [timming]
  )

  useLayoutEffect(() => {
    getQuestionnaireForms({ query, companyId, perPage })
  }, [query, getQuestionnaireForms, companyId, perPage])

  return {
    data,
    total,
    loading,
    error,
  }
}
